export enum TicketRoutePaths {
  appointment = 'appointment',
  cancel = 'cancel',
  change = 'change',
  confirm = 'confirm',
  contact = 'contact',
  customer = 'customer',
  faq = 'faq',
  index = '',
  meterkast = 'meterkast',
  meterkastPrivacyPolicy = 'meterkast/privacy-policy',
  meterkastScheduled = 'meterkast/scheduled',
  questions = 'questions',
  signature = 'sign',
}
